import React from 'react';
import {Route} from "react-router-dom";

import Header from "./Components/Header";
import Footer from "./Components/Footer";

//CSS
import "./Components/css/Styles.css";
import Homepage from './Components/Pages/Homepage';
import MenuPage from "./Components/Pages/MenuPage";

function App() {
  return (
    <div className="App">
      <Header/>
      <Route exact path="/" component={Homepage} />
      <Route exact path="/menu" component={MenuPage} />
      <Footer/>
    </div>
  );
}

export default App;
